'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Button = require('../../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _HelpPopup = require('./HelpPopup');

var _HelpPopup2 = _interopRequireDefault(_HelpPopup);

var _CountIndicator = require('../../../../components/misc/CountIndicator');

var _CountIndicator2 = _interopRequireDefault(_CountIndicator);

var _helpUtilSelector = require('./helpUtilSelector');

var _helpUtilSelector2 = _interopRequireDefault(_helpUtilSelector);

var _popupActions = require('../../../../components/popupPanel/popupActions');

require('./HelpUtil.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Actions
// Lib
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        openPopupPanel: function openPopupPanel() {
            return dispatch((0, _popupActions.togglePopup)('help'));
        }
    };
};

// Styles


// Selector


// Components


var HelpUtil = function HelpUtil(_ref) {
    var popupOpen = _ref.popupOpen,
        unreadMessageCount = _ref.unreadMessageCount,
        openPopupPanel = _ref.openPopupPanel;
    return _react2.default.createElement(
        'div',
        { className: 'HeaderUtil HelpUtil' },
        _react2.default.createElement(
            _Button2.default,
            { className: 'highlight', onClickFn: openPopupPanel },
            _react2.default.createElement(
                'div',
                { className: 'util-icon' },
                _react2.default.createElement(_Icon2.default, { name: 'nav-help' }),
                _react2.default.createElement(_CountIndicator2.default, { count: unreadMessageCount, hide: popupOpen, badge: true })
            ),
            _react2.default.createElement(
                'div',
                { className: 'button-text' },
                _react2.default.createElement(
                    'span',
                    null,
                    'Help'
                )
            )
        ),
        _react2.default.createElement(_HelpPopup2.default, null)
    );
};

HelpUtil.propTypes = {
    popupOpen: _react2.default.PropTypes.bool,
    unreadMessageCount: _react2.default.PropTypes.number,
    openPopupPanel: _propTypes2.default.func
};

exports.default = (0, _reactRedux.connect)(_helpUtilSelector2.default, mapDispatchToProps)(HelpUtil);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/help/HelpUtil.js
// module id = 2182
// module chunks = 0